<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button v-if="hasAdd" type="primary" @click="$router.push('/wlFreight/add')">新增</el-button>
        <el-button v-if="hasExport" type="primary" @click="handleExport">导出</el-button>
      </template>
      <el-form inline ref="searchForm" class="global-form-label-width">
        <el-form-item label="运输公司">
          <el-input v-model="searchForm.transportCompany" placeholder="请输入运输公司" clearable />
        </el-form-item>
        <el-form-item label="运输日期">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            @change="handleDateRangeChange"
          />
        </el-form-item>
        <el-form-item label="送货/进货">
          <el-select v-model="searchForm.transportType" clearable filterable placeholder="请选择送货/进货">
            <el-option v-for="item in transportTypeArr" :key="item" :label="item" :value="item" />
          </el-select>
        </el-form-item>
        <el-form-item label="车船号">
          <el-input v-model="searchForm.vehicleNumber" placeholder="请输入车船号" clearable />
        </el-form-item>
        <el-form-item label="司机姓名">
          <el-input v-model="searchForm.driverName" placeholder="请输入司机姓名" clearable />
        </el-form-item>
        <el-form-item label="货品">
          <el-input v-model="searchForm.goodsName" placeholder="请输入货品" clearable />
        </el-form-item>
        <!-- 新增结算状态筛选 -->
        <el-form-item label="结算状态">
          <el-select v-model="searchForm.settlementStatus" clearable filterable placeholder="请选择结算状态">
            <el-option label="未结算" value="1" />
            <el-option label="已结算" value="2" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card class="mt10" shadow="never">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column show-overflow-tooltip min-width="140" label="运输公司" prop="transportCompany" />
        <el-table-column show-overflow-tooltip min-width="120" label="运输日期" prop="transportDate" />
        <el-table-column show-overflow-tooltip min-width="120" label="送货/进货" prop="transportType"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="车船号" prop="vehicleNumber" />
        <el-table-column show-overflow-tooltip min-width="120" label="司机姓名" prop="driverName" />
        <el-table-column show-overflow-tooltip min-width="160" label="身份证" prop="driverId" />
        <el-table-column show-overflow-tooltip min-width="140" label="联系方式" prop="driverPhone" />
        <el-table-column show-overflow-tooltip min-width="140" label="货品" prop="goodsName" />
        <el-table-column show-overflow-tooltip min-width="100" label="数量" prop="goodsNum" />
        <el-table-column show-overflow-tooltip min-width="100" label="类型" prop="freightType">
          <template #default="{ row }">
            {{ freightTypeMap.get(row.freightType) || '' }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="费用" prop="unitPrice" />
        <el-table-column show-overflow-tooltip min-width="120" label="总价" prop="totalPrice" />
        <el-table-column show-overflow-tooltip min-width="100" label="结算状态" prop="settlementStatus">
          <template #default="{ row }">
            <el-tag :type="row.settlementStatus === '2' ? 'success' : 'warning'">
              {{ settlementStatusMap.get(row.settlementStatus) || '--' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="160" label="创建时间" prop="ctime" />
        <el-table-column fixed="right" label="操作" width="210">
          <template #default="{ row }">
            <el-button type="text" @click="$router.push('/wlFreight/detail?freightId=' + row.freightId)">详情</el-button>
            <el-button type="text" v-if="hasEdit" @click="$router.push('/wlFreight/edit?freightId=' + row.freightId)">编辑</el-button>
            <el-button type="text" v-if="hasEdit && row.settlementStatus === '1'" @click="settleRow(row.freightId)">结算</el-button>
            <el-button type="text" v-if="hasDel" @click="deleteRow(row.freightId)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page.sync="page"
        background
        layout="total, prev, pager, next"
        :total="total"
        @current-change="loadData"
      />
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'WlFreight',
  data() {
    return {
      page: 1,
      total: 0,
      tableData: [],
      loading: false,
      // 独立日期范围变量，不在searchForm内部
      dateRange: null,
      searchForm: {
        transportCompany: null,
        startDate: null,
        endDate: null,
        transportType: null,
        vehicleNumber: null,
        driverName: null,
        goodsName: null,
        settlementStatus: null // 新增结算状态字段
      },
      transportTypeArr: ['送货', '进货'],
      freightTypeMap: new Map([['1', '一口价'], ['2', '单价']]),
      settlementStatusMap: new Map([['1', '未结算'], ['2', '已结算']])
    }
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasDel() {
      return this.buttonList.includes('delete')
    },
    hasExport() {
      return this.buttonList.includes('export')
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    handleDateRangeChange(val) {
      if (val && val.length === 2) {
        this.searchForm.startDate = val[0]
        this.searchForm.endDate = val[1]
      } else {
        this.searchForm.startDate = null
        this.searchForm.endDate = null
      }
    },
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.wlFreight.selectWlFreightByPage, {
        params: { page: this.page, ...this.searchForm }
      }).then(res => {
        this.tableData = res.list || []
        this.total = res.total || 0
      }).finally(() => {
        this.loading = false
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    resetForm() {
      this.$refs.searchForm.resetFields()
      // 重置独立dateRange与searchForm内日期字段
      this.dateRange = null
      this.searchForm = {
        transportCompany: null,
        startDate: null,
        endDate: null,
        transportType: null,
        vehicleNumber: null,
        driverName: null,
        goodsName: null,
        settlementStatus: null
      }
      this.onSearch()
    },
    deleteRow(freightId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.wlFreight.deleteDataWlFreight, { freightId })
          .then(() => this.loadData())
      })
    },
    settleRow(freightId) {
      this.$confirm('确认将该运费明细修改为已结算吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 结算状态只能通过专用接口流转，成功后重新加载列表以隐藏结算按钮。
        this.$axios.post(this.$apis.wlFreight.updateSettlementStatus, { freightId })
          .then(() => this.loadData())
      })
    },
    downloadFile(data, fileName) {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const downloadElement = document.createElement('a')
      const href = window.URL.createObjectURL(blob)
      downloadElement.href = href
      downloadElement.download = decodeURIComponent(fileName)
      document.body.appendChild(downloadElement)
      downloadElement.click()
      document.body.removeChild(downloadElement)
      window.URL.revokeObjectURL(href)
    },
    handleExport() {
      const loadingInstance = this.$loading({
        text: '正在导出...',
        background: 'rgba(0, 0, 0, 0.8)'
      })
      this.$axios.post(this.$apis.wlFreight.exportWlFreight, this.searchForm, {
        responseType: 'blob'
      }).then(res => {
        if (res) {
          const contentDisposition = res.headers['content-disposition']
          let fileName = '运费明细.xls'
          if (contentDisposition) {
            fileName = contentDisposition
              .substring(contentDisposition.indexOf('filename'))
              .split('=')[1]
          }
          this.downloadFile(res.data, fileName)
        }
      }).catch(error => {
        console.error('导出失败:', error)
      }).finally(() => {
        loadingInstance.close()
      })
    }
  }
}
</script>

<style scoped lang="scss">
</style>
